var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 12,
    cy: 9,
    r: 7,
    fill: "#FF5042"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45902 1.39863C5.75191 1.69152 5.75191 2.16639 5.45902 2.45929C4.60008 3.31823 3.91873 4.33794 3.45387 5.4602C2.98901 6.58246 2.74976 7.7853 2.74976 9.00002C2.74976 10.2147 2.98901 11.4176 3.45387 12.5398C3.91873 13.6621 4.60008 14.6818 5.45902 15.5408C6.31796 16.3997 7.33767 17.0811 8.45993 17.5459C9.5822 18.0108 10.785 18.25 11.9998 18.25C13.2145 18.25 14.4173 18.0108 15.5396 17.5459C16.6618 17.0811 17.6816 16.3997 18.5405 15.5408C18.8334 15.2479 19.3083 15.2479 19.6012 15.5408C19.894 15.8337 19.894 16.3085 19.6012 16.6014C18.6029 17.5997 17.4179 18.3915 16.1136 18.9317C15.0409 19.3761 13.9048 19.643 12.7498 19.7238L12.7499 21.25H14.9999C15.4141 21.25 15.7499 21.5858 15.7499 22C15.7499 22.4142 15.4141 22.75 14.9999 22.75H8.9999C8.58569 22.75 8.2499 22.4142 8.2499 22C8.2499 21.5858 8.58569 21.25 8.9999 21.25H11.2499L11.2498 19.7238C10.0948 19.6431 8.95866 19.3761 7.88591 18.9317C6.58166 18.3915 5.39659 17.5997 4.39836 16.6014C3.40013 15.6032 2.60829 14.4181 2.06805 13.1139C1.52781 11.8096 1.24976 10.4117 1.24976 9.00002C1.24976 7.58831 1.52781 6.19043 2.06805 4.88618C2.60829 3.58193 3.40013 2.39685 4.39836 1.39863C4.69125 1.10573 5.16613 1.10573 5.45902 1.39863Z",
    fill: "#FF5042"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.0e697190e979245a792ff90f88dd6dc0.svg";
export { ForwardRef as ReactComponent };